import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import { requireImage } from '@nubank/www-latam-commons/utils/requireImage';
import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

import {
  MediaContent,
  MediaContentFooter,
  MediaGallery,
} from './styles/Media';
import { StyledBlock } from './styles/StyledBlock';

function SectionBrandGuideline() {
  return (
    <Section>
      <Block>
        <Typography
          color="black"
          gutterBottom={2}
          variant="title"
          intlKey="PRESS.BRAND_GUIDE.TITLE"
          intlValues={{ br: <br /> }}
        />

        <Typography
          gutterBottom={1}
          intlKey="PRESS.BRAND_GUIDE.SUBTITLE"
          variant="paragraph2"
        />
      </Block>

      <StyledBlock
        padding={{
          default: paddingBuilder.top(0),
          desktop: paddingBuilder.top(0),
          desktopLarge: paddingBuilder.top(4),
        }}
      >
        <MediaGallery>
          <MediaContent>
            <picture>
              <source
                type="image/webp"
                srcSet={requireImage('press/kit-logo.png', 'webp')}
              />

              <img
                alt=""
                type="image/png"
                src={requireImage('press/kit-logo.png')}
              />
            </picture>

            <MediaContentFooter>
              <Link
                intlKey="PRESS.GALLERY.LOGO"
                color="primary"
                href="https://cdn.nubank.com.br/Press/brand/nubank_logo.zip"
                typographyProps={{
                  variant: 'text2',
                }}
              />
            </MediaContentFooter>
          </MediaContent>

          <MediaContent>
            <picture>
              <source
                type="image/webp"
                srcSet={requireImage('press/kit-icon.png', 'webp')}
              />

              <img
                alt=""
                type="image/png"
                src={requireImage('press/kit-icon.png')}
              />
            </picture>

            <MediaContentFooter>
              <Link
                intlKey="PRESS.GALLERY.ICON"
                color="primary"
                href="https://cdn.nubank.com.br/Press/brand/nubank_icon.zip"
                typographyProps={{
                  variant: 'text2',
                }}
              />
            </MediaContentFooter>
          </MediaContent>

          <MediaContent>
            <picture>
              <source
                type="image/webp"
                srcSet={requireImage('press/kit-ui.png', 'webp')}
              />

              <img
                alt=""
                type="image/png"
                src={requireImage('press/kit-ui.png')}
              />
            </picture>

            <MediaContentFooter>
              <Link
                intlKey="PRESS.GALLERY.APP_SCREENS"
                color="primary"
                href="https://cdn.nubank.com.br/Press/brand/nubank_screens.zip"
                typographyProps={{
                  variant: 'text2',
                }}
              />
            </MediaContentFooter>
          </MediaContent>

          <MediaContent>
            <picture>
              <source
                type="image/webp"
                srcSet={requireImage('press/kit-photos.png', 'webp')}
              />

              <img
                alt=""
                type="image/jpeg"
                src={requireImage('press/kit-photos.png')}
              />
            </picture>

            <MediaContentFooter>
              <Link
                intlKey="PRESS.GALLERY.PICTURES"
                color="primary"
                href="https://cdn.nubank.com.br/Press/brand/nubank_press_pics.zip"
                typographyProps={{
                  variant: 'text2',
                }}
              />
            </MediaContentFooter>
          </MediaContent>
        </MediaGallery>
      </StyledBlock>
    </Section>
  );
}

export default React.memo(SectionBrandGuideline);
